// contexts/ModalContext.ts
import { createContext, type ReactNode, useContext } from 'react';

export interface ModalContextValue {
    openModal: (element: ReactNode) => void;
    closeModal: () => void;
}

export const ModalContext = createContext<ModalContextValue | null>(null);

export const useModal = (): ModalContextValue => {
    const context = useContext(ModalContext);
    if (context === null) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};
